import React from 'react'

const caretLeft = () => {
	return (
		<svg className='caret-left-icon' width='18' height='32' viewBox='0 -1 9 16'>
			<polyline
				stroke='#000'
				fill='none'
				strokeMiterlimit='10'
				points='7.3,14.7 2.5,8 7.3,1.2'
			/>
		</svg>
	)
}

export default caretLeft
